module.exports = __webpack_public_path__ + "img/hr-ccm-universal-04e-blue-LED-on-sequence.9cedc778.png";